import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const CreditLogService = {
  // Define your API functions here
  creditPay: async (customerId, data) => {
    const response = await apiService.post(
      `/creditlogs/customer/${customerId}/pay`,
      data,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },

  getList: async (customerId) => {
    const response = await apiService.get(
      `/creditlogs/customer/${customerId}`,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },
  getAllList: async ({customerId, startDate, endDate}) => {
    const filterList = [];
    if (customerId)
      filterList.push(`customerId=${encodeURIComponent(customerId)}`);
    if (startDate) filterList.push(`startDate=${encodeURIComponent(startDate)}`);
    if (endDate) filterList.push(`endDate=${encodeURIComponent(endDate)}`);
    const filterString =
      filterList.length > 0 ? `?${filterList.join("&")}` : "";
    const response = await apiService.get(`/creditlogs/all${filterString}`, {
      headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },

  getSummary: async (period) => {
    const response = await apiService.get(`/creditlogs/summary/${period}`, {
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
};

export default CreditLogService;
